import styles from './style.module.scss';
import { src } from '../../../utils/common';
import { WebPNativeImage } from '../../WebPImage';

const DescCard = ({ demoTitle, demoDesc }) => {
  return (
    <section className={styles['list-container']}>
      <div className={styles['list-item-icon']}>
        <WebPNativeImage
          src={src('/img/title-icon.webp')}
          style={{ width: 13, height: 12 }}
        ></WebPNativeImage>
      </div>
      <div className={styles['list-item-header']}>{demoTitle}</div>
      <div className={styles['list-item-element']}>
        {demoDesc.map((item, index) => {
          return (
            <div key={item.title} className={styles['list-item-container']}>
              <header className={styles['list-item-title']}>
                {item.title}
              </header>
              <div className={styles['list-item-subtitle']}>
                {item.subTitle}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default DescCard;
